/**
 * 点击拖拽
 */
import utils from './utils.js';

export const Drag = function () {}

/**
 * 绑定拖拽事件
*/
Drag.prototype.binddragMove = function(canvas, cover) {
    if (utils.browserIsPc()) {
        this.dragMove(canvas, cover)
    } else {
        this.touchMove(canvas, cover)
    }
}

/**
 * 鼠标点击拖拽移动事件
 */
Drag.prototype.dragMove = function (canvas, cover) {
    let _this = this
    canvas.onmousedown = function(ev) {
        let oEvent = _this._prEvent(ev),
            oParent = canvas.parentNode,
            disX = oEvent.clientX - canvas.offsetLeft,
            disY = oEvent.clientY - canvas.offsetTop,
        startMove = function(ev) {
            if (oParent.setCapture) {
                oParent.setCapture();
            }
            let oEvent = ev || window.event,
            L = oEvent.clientX - disX,
            T = oEvent.clientY - disY;

            canvas.style.left = L +'px';
            canvas.style.top = T +'px';

            if (cover) {
                cover.style.left = L +'px';
                cover.style.top = T +'px';
            }

            oParent.onselectstart = function() {
                return false;
            }
        }, 
        endMove = function(ev) {
            if (oParent.releaseCapture) {
                oParent.releaseCapture();
            }
            oParent.onselectstart = null;
            _this._removeEvent(oParent, 'mousemove', startMove);
            _this._removeEvent($('body')[0], 'mouseup', endMove);
        };
        _this._addEvent(oParent, 'mousemove', startMove);
        _this._addEvent($('body')[0], 'mouseup', endMove);
        return false;
    }
}

/**
 * 触摸移动事件
 */
Drag.prototype.touchMove = function(canvas, cover) {
    let _this = this
    canvas.ontouchstart = function(ev) {
        if(ev.touches.length==2){
            return false;
        }
        let oEvent = _this._prEvent(ev),
        oParent = canvas.parentNode,
        disX = oEvent.targetTouches[0].clientX - canvas.offsetLeft,
        disY = oEvent.targetTouches[0].clientY - canvas.offsetTop,
        startMove = function(ev) {
            if (oParent.setCapture) {
                oParent.setCapture();
            }
            let oEvent = ev || window.event,
                L = oEvent.targetTouches[0].clientX - disX,
                T = oEvent.targetTouches[0].clientY - disY;

            canvas.style.left = L +'px';
            canvas.style.top = T +'px';
            if (cover) {
                cover.style.left = L +'px';
                cover.style.top = T +'px';
            }

            oParent.onselectstart = function() {
                return false;
            }
        }, endMove = function(ev) {
            if (oParent.releaseCapture) {
                oParent.releaseCapture();
            }
            oParent.onselectstart = null;
            _this._removeEvent(oParent, 'touchmove', startMove);
            _this._removeEvent(oParent, 'touchend', endMove);
        };
        _this._addEvent(oParent, 'touchmove', startMove);
        _this._addEvent(oParent, 'touchend', endMove);
        return false;
    }
}

Drag.prototype._addEvent = function(obj, sType, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(sType, fn, false);
    } else {
        obj.attachEvent('on' + sType, fn);
    }
}

Drag.prototype._removeEvent = function(obj, sType, fn) {
    if (obj.removeEventListener) {
        obj.removeEventListener(sType, fn, false);
    } else {
        obj.detachEvent('on' + sType, fn);
    }
}

Drag.prototype._prEvent = function(ev) {
    let oEvent = ev || window.event;
    if (oEvent.preventDefault) {
        oEvent.preventDefault();
    }
    return oEvent;
}
